import { doc, getDoc, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import {
  CONTACT_TO_BUILD_STEPS,
  CONTACT_TO_BUILD_GOAL,
  CONTACT_TO_BUILD_NOTE,
} from '../data/contactToBuildDefault';

/**
 * The single CRM-managed master "Contact to Build" SOP template. The portal reads
 * it as the default for every account (an account can still override the steps in
 * its own accounts/{id}/contactToBuildSOP/data doc). Editing it in the CRM SOP
 * Templates page updates the default all un-customized accounts see.
 */
const templateRef = () => doc(db, 'contactToBuildTemplate', 'data');

/** Built-in default (used when no CRM master template has been saved). */
export const contactToBuildDefault = () => ({
  steps: CONTACT_TO_BUILD_STEPS.map((s) => ({ ...s })),
  goal: CONTACT_TO_BUILD_GOAL,
  note: CONTACT_TO_BUILD_NOTE,
  version: '1.0',
});

/**
 * @returns {Promise<{steps, goal, note, version, isCustom:boolean}>}
 * isCustom is true when a saved master template exists (vs the built-in default).
 */
export async function fetchContactToBuildTemplate() {
  try {
    const snap = await getDoc(templateRef());
    if (snap.exists()) {
      const d = snap.data();
      const base = contactToBuildDefault();
      return {
        steps: Array.isArray(d.steps) && d.steps.length ? d.steps : base.steps,
        goal: d.goal || base.goal,
        note: d.note || base.note,
        version: d.version || '1.0',
        isCustom: true,
      };
    }
  } catch (err) {
    console.error('Error fetching Contact to Build template:', err);
  }
  return { ...contactToBuildDefault(), isCustom: false };
}

export async function saveContactToBuildTemplate({ steps, goal, note, version }) {
  await setDoc(templateRef(), {
    steps: steps || [],
    goal: goal || '',
    note: note || '',
    version: version || '1.0',
    updatedAt: serverTimestamp(),
  });
}

/** Remove the master template so the built-in default takes over again. */
export async function resetContactToBuildTemplate() {
  await deleteDoc(templateRef());
}
